<template>
	<div id="body">
		<!-- Page Loader -->
		<div class="page-loader-wrapper" v-if="isCarregando">
			<div class="loader">
				<div class="spinner-container">
					<div class="spinner">
						<div class="spinner-ring"></div>
						<div class="spinner-ring"></div>
						<div class="spinner-ring"></div>
					</div>
				</div>
				<p class="loading-text">Carregando...</p>        
			</div>
		</div>

		<!-- Theme Setting -->
		<div class="themesetting" v-if="isLogado">
			<div>
				<a href="javascript:void(0);" class="theme_btn" id="geral_step4"><i class="fas fa-cog fa-spin"></i></a>
			</div>
			<ul class="list-group">
				<li class="list-group-item">
					<ul class="choose-skin list-unstyled mb-0">
						<li data-theme="blue"><div class="blue rounded cursor-pointer"></div></li>
						<li data-theme="green"><div class="green rounded cursor-pointer"></div></li>
						<li data-theme="orange"><div class="orange rounded cursor-pointer"></div></li>
						<li data-theme="blush"><div class="blush rounded cursor-pointer"></div></li>
						<li data-theme="cyan"><div class="cyan rounded cursor-pointer"></div></li>
						<!-- <li data-theme="timber"><div class="timber rounded cursor-pointer"></div></li> -->
						<li data-theme="amethyst"><div class="amethyst rounded cursor-pointer"></div></li>
					</ul>
				</li>
				<li class="list-group-item d-flex align-items-center justify-content-between">
					<span>Modo escuro</span>
					<label class="switch dark_mode">
						<input type="checkbox">
						<span class="slider round"></span>
					</label>
				</li>
			</ul>
		</div>

		<!-- Overlay For Sidebars -->
		<div class="overlay"></div>

		<div id="wrapper" v-if="isLogado">
			<!-- Page top navbar -->
			<NavBar />
        
			<!-- Main left sidebar menu -->
			<Lateral @abrirEditarSenha="abrirEditarSenha" @abrirEditarFoto="abrirEditarFoto" />

			<!-- modalEditarFoto -->
			<div class="modal fade" id="modalEditarFoto" tabindex="-1" data-backdrop="static" aria-labelledby="modalEditarFotoLabel" aria-hidden="true">
				<div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document">
					<div class="modal-content h-100">
						<div class="modal-header">
							<h5 class="modal-title h4" id="modalEditarFotoLabel">Editar foto</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
						</div>
						<div class="modal-body">
							<div class="card">
								<div class="card-body">
									<div class="row">
										<div class="col-sm-6">
											<div class="form-group file-area">
												<label for="images"><i class="fa fa-image color-theme mr-1"></i> Foto</label>
												<input type="file" class="dropify" name="images" id="images" ref="images" accept=".jpg,.jpeg,.png,.webp" required="required" @change="onFileChange" @drop="onFileChange" @click="onFileChange" />
												<div class="file-dummy">
													<div class="default">Selecione uma foto</div>
												</div>
											</div>
										</div>

										<div class="col-sm-6 mx-auto pt-3 mt-1 position-relative" v-if="imageTemporary != null">
											<div class="cropper-box">
												<cropper class="cropper" :src="imageTemporary" :stencil-props="{ minAspectRatio: 16/16, maxAspectRatio: 4/4 }" :auto-zoom="true" :backgroundClass="'bg-white'" @change="change" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-round btn-primary" @click="salvarFoto">Salvar</button>
							<button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
						</div>
					</div>
				</div>
			</div>

			<!-- modalEditarSenha -->
			<div class="modal fade" id="modalEditarSenha" tabindex="-1" data-backdrop="static" aria-labelledby="modalEditarSenhaLabel" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title h4" id="modalEditarSenhaLabel">Editar senha</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
						</div>
						<div class="modal-body">
							<div class="card mb-0">
								<div class="card-body">
									<div class="row m-0">
										<div class="col-12 px-1 mb-3">
											<label class="mb-1"><i class="fa fa-lock color-theme mr-1"></i> Nova senha</label>
											<input type="text" class="form-control key" v-model="modalSenha.senha" />
										</div>
										<div class="col-12 px-1">
											<label class="mb-1"><i class="fa fa-lock color-theme mr-1"></i> Repetir senha</label>
											<input type="text" class="form-control key" v-model="modalSenha.novaSenha" @keyup.enter="salvarSenha" />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-round btn-primary" @click="salvarSenha">Salvar</button>
							<button type="button" class="btn btn-round btn-secondary" data-dismiss="modal">Fechar</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Main body part  -->
			<div id="main-content">
				<div class="container-fluid">
					<router-view class="pt-4" />
				</div>
			</div>
		</div>

		<Login v-if="!isLogado" />
	</div>
</template>

<script>
import $ from 'jquery'
import { mapState } from 'vuex'
import Login from '@/views/Login.vue'
import NavBar from '@/components/MenuNavBar.vue'
import Lateral from '@/components/MenuLateral.vue'

export default {
	name: 'App',
	data: function() {
		return {
         imageTemporary: null,
         image: null,
         modalSenha: {'senha': '', 'novaSenha': ''}
		}
	},
	computed: {
		... mapState({
			dadosUsuario: state => state.dadosUsuario,
			isCarregando: state => state.isCarregando,
			isLogado: state => state.isLogado,
         urlRest: state => state.urlRest
		})
	},
	watch: {
		isLogado : function(value) {
			if (value) {
				require("@/assets/vendor/bootstrap/js/bootstrap.bundle.js")

				setTimeout(() => {
					if (localStorage.getItem('tour_geral') !== 'ok') {
						// this.startTour();
					}
				}, 500);
			}
		}
	},
	components: {
		Lateral, NavBar, Login
	},
	methods: {
		change({ coordinates, canvas }) {
         coordinates;
			this.$refs.images.value = null;
         this.image = canvas.toDataURL('image/jpeg');
		},
      onFileChange(e) {
         var files = e.target.files || e.dataTransfer.files;
         if (!files.length)
         return;
         this.createImage(files[0]);
      },
      createImage(file) {
         var reader = new FileReader();
         var vm = this;

         reader.onload = (e) => {
            vm.imageTemporary = e.target.result;
         };
         reader.readAsDataURL(file);
      },
      abrirEditarSenha() {
         this.modalSenha = {'senha': '', 'novaSenha': ''}

         $('#modalEditarSenha').modal('show')
      },
      abrirEditarFoto() {
         this.imageTemporary = null
         this.image = null

         $('#modalEditarFoto').modal('show')
      },
      salvarFoto() {
         if (this.image == null || String(this.image).length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Foto inválida!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/changephoto',
            headers: {
					'Content-Type': 'application/json'
            },
				data: JSON.stringify({
               idUsuario: this.dadosUsuario.usuarioId,
               foto: this.image
            })
         }).then(function () {
				$('#modalEditarFoto').modal('hide')
            ref.dadosUsuario.usuarioFoto = ref.image

            ref.$toast.fire({
               icon: 'success',
               title: 'Foto alterada!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
                  ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
      },
      salvarSenha() {
         if (this.modalSenha.senha == null || (this.modalSenha.senha.trim().length > 0 && this.modalSenha.senha.trim().length < 4)) {
            this.$toast.fire({
               icon: 'error',
               title: 'Digite ao menos 4 caracteres!'
            })

            return
         } else if (this.modalSenha.senha.trim() != this.modalSenha.novaSenha.trim()) {
            this.$toast.fire({
               icon: 'error',
               title: 'Senhas direfentes!'
            })

            return
         }

         let ref = this;
			this.$store.dispatch('alternarTelaCarregamento', true)

         this.$axios({
            method: 'post',
            url: this.urlRest +'usuarios/changePassword',
				params: {
               idUsuario: this.dadosUsuario.usuarioId,
               senha: this.modalSenha.senha
            }
         }).then(function () {
				$('#modalEditarSenha').modal('hide')

            ref.$toast.fire({
               icon: 'success',
               title: 'Senha salva!'
            })
         }).catch(function (error) {
            if (error.response != undefined) {
               if (error.response.status == 408) {
						ref.$store.dispatch('deslogar')

                  ref.$toast.fire({
                     icon: 'warning',
                     title: 'Sessão expirada!'
                  });
               } else {
                  ref.$toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  })
               }
            } else {
               ref.$toast.fire({
                  icon: 'error',
                  title: error
               })
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', false)
         })
		},
		startTour() {
			const steps = [];

			// Verifica largura da tela
			const larguraTela = window.innerWidth;

			// Pegando permissões do usuário
			const permissoes = this.dadosUsuario?.usuarioPermissoes || [];

			// Step 1 e 2 só se tela > 1280
			if (larguraTela > 1280) {
				steps.push({
					element: '#geral_step1',
					intro: 'Configure seu perfil de usuário quando achar necessário.'
				});
				steps.push({
					element: '#geral_step2',
					intro: 'Mude a forma como a barra lateral se comporta.'
				});
			}

			// Step 3 só se tela > 770
			if (larguraTela > 770) {
				steps.push({
					element: '#geral_step3',
					intro: 'Coloque em tela cheia para ter uma melhor experiência.'
				});
			}

			// Step 4 sempre entra
			steps.push({
				element: '#geral_step4',
				intro: 'Mude as cores do sistema para melhorar a visualização.'
			});

			// Step 5: precisa de "Ver/Adicionar Usuários"
			if (permissoes.includes('Ver/Adicionar Usuários')) {
				steps.push({
					element: '#geral_step5',
					intro: 'Inicie criando e gerenciando os usuários que terão acesso ao sistema por aqui.'
				});
			}

			// Step 6: só entra se a permissão do step 5 existir
			if (permissoes.includes('Ver/Adicionar Entidades')) {
				steps.push({
					element: '#geral_step6',
					intro: 'O sistema requer que existam entidades cadastradas.'
				});
			}

			// Step 7: precisa de "Ver/Adicionar Sentenciados"
			if (permissoes.includes('Ver/Adicionar Sentenciados')) {
				steps.push({
					element: '#geral_step7',
					intro: 'Com tudo pronto, o próximo passo é cadastrar os sentenciados.'
				});
			}

			// Inicia o tour com os steps filtrados
			this.$intro().setOptions({
				steps
			}).start();

			localStorage.setItem('tour_geral', 'ok')
		}
	},
	mounted(){
		this.$store.dispatch('verificarCredenciais')
  }
}

</script>

<style scoped>
.spinner-container {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 0;
}

.spinner {
	position: relative;
	width: 70px;
	height: 70px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.spinner-ring {
	position: absolute;
	border: 4px solid transparent;
	border-radius: 50%;
	animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;
}

.spinner-ring:nth-child(1) {
	width: 70px;
	height: 70px;
	border-top-color: var(--primary-color);
	animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
	width: 55px;
	height: 55px;
	border-right-color: var(--primary-color);
	animation-delay: -0.3s;
	animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
	width: 40px;
	height: 40px;
	border-bottom-color: var(--primary-color);
	animation-delay: -0.6s;
}

@keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.loading-text {
	margin-top: 20px;
	font-size: 16px;
	font-weight: 800;
	color: var(--primary-color);
	animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
	0%, 100% {
		opacity: 1;
	}
	50% {
		opacity: 0.5;
	}
}
</style>